<template>
  <section>
    <el-form class="form_cls" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent inline>
      <el-form-item label="手术开始日期">
        <el-date-picker
          :prefix-icon="isMobile ? '11' : ''"
          style="width: 130px !important"
          v-model="filters.start_date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期"
          :picker-options="startDateOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="手术结束日期">
        <el-date-picker
          :prefix-icon="isMobile ? ' ' : ''"
          style="width: 130px !important"
          v-model="filters.end_date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
          :picker-options="endDateOptions"
        ></el-date-picker>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item
        v-if="!item.IsHide && (isMobile && item.name == '导出' ? false : true)"
        class="input_width_100"
        v-for="item in buttonList"
        v-bind:key="item.id"
      >
        <!-- 这里触发点击事件 -->
        <el-button
          style="margin-bottom: 8px"
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div" style="margin-bottom: 5px;">
      <el-table
        :data="tabel_list.hospitals"
        :border="true"
        :span-method="objectSpanMethod"
        :cell-style="cellStyle"
        cell-class-name="cell_class_name"
        max-height="100%"
        header-cell-class-name="header_cell_name"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
      >
        <el-table-column prop="name" label="医院名称" :min-width="isMobile ? '120' : ''" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column v-if="!isMobile" prop="regionName" label="区域" width="120">
          <template slot-scope="scope">
            {{ scope.row.regionName || '-' }}
          </template>
        </el-table-column>
        <el-table-column v-if="!isMobile" prop="salesName" label="姓名" width="100">
          <template slot-scope="scope">
            {{ scope.row.salesName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="todaylabel">
          <el-table-column prop="mtdNumber" label="指标" :width="isMobile ? '50' : '60'">
            <template slot-scope="scope">
              <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:10px'">
                {{ currency(tabel_list.total.target) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="mtdNumber" label="达成" :width="isMobile ? '50' : '60'">
            <template slot-scope="scope">
              <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:10px'">
                {{ (tabel_list.total.achieve * 100).toFixed(0) }}%
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="数量" :width="isMobile ? '50' : '60'">
            <template slot-scope="scope">
              <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:10px'">{{ currency(scope.row.number) }}</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </section>
</template>

<script>
import { flacs_getsalemtddata } from '../../api/api'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      todaylabel: '',
      isMobile: false,
      tableHeight: 0,
      buttonList: [],
      token: '',
      filters: {
        pageSize: 200,
        start_date: '',
        end_date: '',
      },
      tabel_list: [],
      pageNumber: 1,
      listLoading: false,
    }
  },
  computed: {
    // 开始日期选择限制：不能晚于结束日期，不能选择明天及以后
    startDateOptions() {
      const self = this
      return {
        disabledDate(time) {
          // 禁用今天及以后的日期
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          if (time.getTime() > today.getTime()) {
            return true
          }
          
          // 禁用晚于结束日期的日期
          if (self.filters.end_date) {
            return time.getTime() > new Date(self.filters.end_date).getTime()
          }
          return false
        }
      }
    },
    // 结束日期选择限制：不能早于开始日期，不能选择明天及以后
    endDateOptions() {
      const self = this
      return {
        disabledDate(time) {
          // 禁用今天及以后的日期
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          if (time.getTime() > today.getTime()) {
            return true
          }
          
          // 禁用早于开始日期的日期
          if (self.filters.start_date) {
            const startDate = new Date(self.filters.start_date)
            startDate.setHours(0, 0, 0, 0)
            const compareDate = new Date(time)
            compareDate.setHours(0, 0, 0, 0)
            return compareDate.getTime() < startDate.getTime()
          }
          return false
        }
      }
    }
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      console.log(row, column, rowIndex, columnIndex)
      // 手机端隐藏了区域和姓名列，指标和达成列索引为1和2；PC端为3和4
      const targetCols = this.isMobile ? [1, 2] : [3, 4]
      if (targetCols.includes(columnIndex)) {
        if (rowIndex === 0) {
          return {
            rowspan: this.tabel_list.hospitals.length,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
      return { rowspan: 1, colspan: 1 }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {},
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },
    currency(val) {
      if (val == '' || val == null) {
        return val
      }
      if (Number(val) == 0) {
        return 0
      }
      let precision = 0
      let decimal = this.checkNaN(val, (v) => v.toFixed(precision))
      const [n, d = []] = decimal.toString().split('.')
      return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].concat(d).join('.')
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
      //   this.getModules2()
    },
    //获取用户列表
    getModules() {
      let para = JSON.parse(JSON.stringify(this.filters))
      para.pageNumber = this.pageNumber
      if (para.start_date == para.end_date) {
        this.todaylabel = para.start_date
      } else {
        this.todaylabel = para.start_date + '至' + para.end_date
      }
      this.listLoading = true
      flacs_getsalemtddata(para).then((res) => {
        // this.total = res.data.data.dataCount
        this.tabel_list = res.data
        this.listLoading = false
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    if (window.innerWidth <= 767) {
      this.isMobile = true
      this.collapsedClass = 'menu-collapsed'
      //   this.SidebarVisible = false
    }
    var time = new Date()
    var year = time.getFullYear()
    var month = time.getMonth() + 1
    var day = time.getDate()
    var todays = year + '-' + (Number(month) < 10 ? '0' + month : month) + '-' + (Number(day) < 10 ? '0' + day : day)
    this.filters.start_date = todays
    this.filters.end_date = todays
    // this.todaylabel = todays
    this.getModules_search()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style>
.expends_cls .cell {
  padding: 0 5px !important;
}
.el-collapse-item__header {
  font-size: 14px !important;
  font-weight: bold !important;
  /* background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: 1px solid rgb(203, 203, 203) !important; */
  padding-left: 5px !important;
}
.cell_class_name {
  text-align: center !important;
}
/* .el-input__inner {
  padding: 5px !important;
} */
.el-collapse-item__wrap {
  background-color: none !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
.expends_cls td.el-table__cell {
  padding: 1px 0 !important;
}
</style>
